import { createSlice } from '@reduxjs/toolkit';

export interface ErrorState {
  hasError: boolean;
}

export const initialState: ErrorState = {
  hasError: false,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    errorThrown(state) {
      state.hasError = true;
    },
  },
});

export const { errorThrown } = errorSlice.actions;

export default errorSlice.reducer;
